import React, { useState } from "react";
import { Link } from "gatsby";
import {useLocation } from '@reach/router';

function DropdownMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsMenuOpen(true);
  };

  const handleMouseLeave = () => {
    setIsMenuOpen(false);
  };

  const location = useLocation();
  const lang = location.pathname.startsWith("/en") ? "en" : "nl";

  return (
    <div
      className="relative hidden lg:inline-block text-left"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="cursor-pointer font-inter justify-center rounded-md px-2 py-2 font-semibold hover:bg-opacity-30 relative hover:no-underline hover:after:content-[''] hover:after:absolute hover:after:left-2 hover:after:w-20 hover:after:bottom-[-2px] hover:after:h-[2px] hover:after:bg-current transition-all duration-300"
      >
        {lang === "en" ? "Themes" : "Thema's"}
        
      </div>

      {isMenuOpen && (
        <div
          className="fixed left-0 w-full bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50 font-inter mt-1"
        >
          <div className="max-w-screen-lg mx-auto grid grid-cols-4 gap-x-3 gap-y-6 p-6 text-sm font-semibold"> {/* Gecentreerd met max-w-screen-lg en mx-auto */}
            
            {/* Frankrijk sectie */}
            
            <div>
    

           

            {/* Spanje sectie */}
          
              
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Age Category" : "Leeftijdscategorie"}
              </h3>
              

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/jongeren/">
                    {lang === "en" ? "Juniors (- 18)" : "Juniors (- 18)"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/18plus/">
                    {lang === "en" ? "18 - 20 years old" : "18 - 20 jaar"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/20plus/">
                    {lang === "en" ? "20 - 25 years old" : "20 - 25 jaar"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/25plus/">
                    {lang === "en" ? "25 - 30 years old" : "25 - 30 jaar"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/30plus/">
                    {lang === "en" ? "30+ years old" : "30 + jaar"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/families/">
                    {lang === "en" ? "Families" : "Families"}
                  </Link>
                </li>
              </ul>

              <Link to="/surfvakanties/portugal">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Type of Traveller" : "Type reiziger"}
              </h3>
              </Link>
              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/solo-reizigers">
                    {lang === "en" ? "Solo Travellers" : " Solo-reizigers"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link>
                    {lang === "en" ? "Friends (coming soon)" : "Vrienden/vriendinnen (coming soon)"}
                  </Link>
                </li>
                        
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/koppels">
                    
                    {lang === "en" ? "Couples" : "Koppels"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/families">
                    Families
                  </Link>
                </li>
              </ul>
       
            </div>

            {/* Portugal sectie */}
            <div>
     

          <Link to="/surfvakanties/frankrijk">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Type of Accommodation" : "Type accommodatie"}
              </h3>
              </Link>

              <ul className="list-none text-slate-500">
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/surfkampen" >
                    {lang === "en" ? "Surf Camp" : "Surfkamp"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/surflodges">
                    {lang === "en" ? "Surf Lodge" : "Surflodge"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/surf-hotels-resorts">
                    {lang === "en" ? "Surf Hotels & Resorts" : "Surf Hotels & Resorts"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/glamping">
                    {lang === "en" ? "Glamping" : "Glamping"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/surf-en-taalreizen/">
                    {lang === "en" ? "Surf & Language" : "Surf &amp; Taalreizen"}
                  </Link>
                </li>
              </ul>

          <Link to="/surfvakanties/frankrijk">
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Theme" : "Thema"}
              </h3>
          </Link>

              <ul className="list-none text-slate-500">
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/yoga/" >
                    {lang === "en" ? "Surf & Yoga" : "Surf & Yoga"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/busreizen">
                    {lang === "en" ? "Bus Trips" : "Busreizen"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/kitesurfen">
                    {lang === "en" ? "Kite Surfing" : "Kitesurfen"}
                  </Link>
                </li>
                <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/digital-nomads/">
                    {lang === "en" ? "Digital Nomads" : "Digital Nomads"}
                  </Link>
                </li>
              </ul>

            </div>

            {/* Costa Rica en andere bestemmingen */}
            <div>
        
              <h3 className="text-lg mb-2">
                {lang === "en" ? "Season" : "Seizoen"}
              </h3>
              
              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/lente">
                   {lang === "en" ? "Lente" : "Spring"}
                  </Link>
              </li>
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/zomer">
                    {lang === "en" ? "Summer" : "Zomer"}
                  </Link>
              </li>
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/herfst">
                   {lang === "en" ? "Autumn" : "Herfst"}
                  </Link>
              </li>
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/winter">
                   {lang === "en" ? "Winter" : "Winter"}
                  </Link>
              </li>

              </ul>


              <h3 className="text-lg mb-2">Families</h3>
              
              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/families">
                   {lang === "en" ? "All Family Surf Camps" : "Alle Familie Vakanties"}
                  </Link>
              </li>
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/families/frankrijk">
                   {lang === "en" ? "France" : "Frankrijk"}
                  </Link>
              </li>
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/families/spanje">
                   
                   {lang === "en" ? "Spain" : "Spanje"}
                  </Link>
              </li>
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/families/portugal">
                   Portugal
                   
                  </Link>
              </li>

              </ul>
            </div>

            {/* Sri Lanka en Indonesië */}
            <div>
            <Link to="/surfvakanties/sri-lanka">
              <h3 className="text-lg mb-2"> 
                  {lang === "en" ? "Month" : "Maand"}
              </h3>
            </Link>

              <ul className="list-none text-slate-500">
              <li className="ml-0 mb-1">
                  <Link to="/surfvakanties/januari">
                   {lang === "en" ? "January" : "Januari"}
                  </Link>
                </li>
                
                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/februari">
                   {lang === "en" ? "February" : "Februari"}
                  </Link>
                </li>
                
                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/maart">
                  {lang === "en" ? "March" : "Maart"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/april">
                  April
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/mei">
                   
                    {lang === "en" ? "May" : "Mei"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/juni">
                   
                   {lang === "en" ? "June" : "Juni"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/juli">
                   {lang === "en" ? "June" : "Juli"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/augustus">
                   {lang === "en" ? "August" : "Augustus"}
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/september">
                   September
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/oktober">
                   {lang === "en" ? "October" : "Oktober"}
                </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/november">
                   November
                  </Link>
                </li>

                <li className="ml-0 mb-1">
                <Link to="/surfvakanties/december">
                December
                  </Link>
                </li>
              </ul>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DropdownMenu;
